import styled from "styled-components";

interface Props {
  inactive?: boolean;
  newCard?: boolean;
  enableNewCard?: boolean;
}

const CardContainer = styled.div<Props>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 10px 10px 8px 10px;
  background: #ffffff;
  opacity: ${({ inactive }) => (inactive ? "30%" : "100%")};;
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  overflow: hidden;
`;

const CardSummary = styled.div`
  display: flex;
  justify-content: space-between;
`;

const CardHeader = styled.div`
  width: 100%;
`;

const CardActions = styled.div`
  width: 40px;
  max-width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ContentAction = styled.div<Props>`
  height: ${({ enableNewCard }) => (enableNewCard ? "55%" : "100%")};
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-evenly;
  margin-bottom: ${({ enableNewCard }) => (enableNewCard ? "15px" : "0")};
`;

const IconNewCard = styled.div<Props>`
  margin-bottom: 5px;
  visibility: ${({ newCard }) => (newCard ? "visible" : "hidden")};
`;

const CardDetails = styled.div`
  height: 0px;
  overflow: overlay;
  transition: height 300ms linear;
  scrollbar-width: none;
  margin-top: 15px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const CardToggleButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

interface CardToggleButtonProps {
  expanded: boolean;
}
const CardToggleButton = styled.div<CardToggleButtonProps>`
  height: 5px;
  width: 42%;
  background-color: ${({ expanded }) => (expanded ? "#E3E3E3" : "#BEBEBE")};
  border-radius: 10px;
`;

export {
  CardContainer,
  CardSummary,
  CardHeader,
  CardActions,
  CardDetails,
  CardToggleButtonContainer,
  CardToggleButton,
  IconNewCard,
  ContentAction
};
